import { ScheduleApi, ScheduleTypes } from '@frontend/api-schedule';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { ServiceProvidersConstants } from '@frontend/api-service-providers';
import { useQuery } from '@frontend/react-query-helpers';
import { queryKeys } from '../../query-keys';

const { getOfficeHoursForMultipleLocationIds } = ScheduleApi;
const { ONE_MINUTE_IN_MILLISECONDS } = ServiceProvidersConstants;

export const useGetOfficeHoursForMultipleLocationIds = (
  request: ScheduleTypes.GetOfficeHoursForMultipleLocationIdsType['input']
) => {
  const { isScheduleV3FlagEnabled } = SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();
  return useQuery({
    queryKey: queryKeys.officeHoursForMultipleLocationIds(request.locationIds ?? []),
    queryFn: () => getOfficeHoursForMultipleLocationIds(request),
    retry: 1,
    cacheTime: 60 * ONE_MINUTE_IN_MILLISECONDS, // 1hr
    staleTime: 60 * ONE_MINUTE_IN_MILLISECONDS, // 1hr,
    enabled: !!request.locationIds?.length && !isScheduleV3FlagEnabled,
    select: ({ officeHoursData }) => (officeHoursData ? officeHoursData : []),
    onSettled: () =>
      SchedulerV3.trackScheduleAPIVersionChange('v2', { endpoint: 'getOfficeHoursForMultipleLocationIds' }),
  });
};
